export function shortTaskId(value: string | null | undefined) {
  const id = String(value || '').trim()
  return id.length > 16 ? `#${id.slice(-12)}` : id || '—'
}
